@let error = errorMessageService.error();
@if (error) {
  <div class="toaster toaster-bottom toaster-center">
    <div class="alert alert-error px-4">
      {{ error | translate }}
    </div>
  </div>
}
